import {
  AdminOverviewStatus,
  ApprovePayload,
  StatusReq,
  TAwaitingApprovalRes,
  TRecentActivityRes,
} from '@src/types';
import axios, { AxiosResponse } from 'axios';

export const getAwaitingApproval = async (
  params: StatusReq
): Promise<AxiosResponse<TAwaitingApprovalRes>> => {
  return axios.get('/leeloo-accounts/awaiting-approval', {
    params: { ...params, size: 20 },
  });
};

export const getPendingEval = async (): Promise<AxiosResponse<number>> => {
  return axios.get('/leeloo-accounts/pending-eval');
};

export const getPendingPerformanceAccount = async (
  params: StatusReq
): Promise<AxiosResponse<TAwaitingApprovalRes>> => {
  return axios.get('/leeloo-accounts/awaiting-document-signature-or-purchase', {
    params: { ...params, size: 20 },
  });
};

export const approveStatus = async (payload: ApprovePayload) => {
  return await axios.post('/account-evaluation/approve', payload);
};

export const denyStatus = async (payload: ApprovePayload) => {
  return await axios.post('/account-evaluation/deny', payload);
};

export const blockStatus = async (payload: ApprovePayload) => {
  return await axios.post('/account-evaluation/block', payload);
};

export const resendInvite = async (payload: ApprovePayload) => {
  return await axios.post('/account-evaluation/resend-eval-email', payload);
};

export const bulkApproveStatus = async (payload: ApprovePayload[]) => {
  return await axios.post('/account-evaluation/bulk-approve', {
    eval_request_approve: payload,
  });
};

export const getOverViewStatus = async (): Promise<
  AxiosResponse<AdminOverviewStatus>
> => {
  return axios.get('/mint-overview/');
};

export const getRecentActivity = async (
  params?: StatusReq
): Promise<AxiosResponse<TRecentActivityRes>> => {
  return axios.get('/recent-activity/', {
    params: { ...params, size: params?.size || 20 },
  });
};
